import React, { useEffect, useState } from "react";
import Layout from "../../../layout";
import { Grid, GridItem, Box, filter } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardCountRequest } from "../ipsStore/actions";
import PrimarySideHeader from "../../../components/PrimarySideHeader";
import CountCard from "../components/CountCard";
import { useNavigate } from "react-router-dom";
import { filtersPayload } from "../../utils";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dashboardCount } = useSelector((state) => state.ips);

  const [filters, setFilters] = useState({
    country: [],
    healthConcern: [],
    hospital: [],
    gender: [],
    daysFilter: "",
    fromDate: "",
    toDate: "",
    dateError: "",
  });
  useEffect(() => {
    const payload = {
      source: "Web",
      screen: "all",
    };
    dispatch(fetchDashboardCountRequest(payload));
  }, [dispatch]);

  // const handleDateFilterApply = (dateRange) => {
  //   let payload = new FormData();
  //   payload.append("from_date", dateRange.fromDate);
  //   payload.append("to_date", dateRange.toDate);
  //   payload.append("screen", "all");
  //   payload.append("source", "Web");
  //   dispatch(fetchDashboardCountRequest(payload));
  // };

  const formatSectionName = (section) => {
    if (section === "vil_requests") {
      return "VIL Requests";
    }
    if (section === "pre_intimation") {
      return "Pre-Intimation";
    }
    return section
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleCardClick = (filter, label) => {
    const routes = {
      medical_opinion: "/medical_opinion-patient_list",
      vil_requests: "/vil_requests-patient_list",
      patient_arrivals: "/patient_arrivals-patient_list",
      pre_intimation: "/pre_intimation-patient_list",
    };

    const route = routes[filter];
    if (route) {
      navigate(`${route}?label=${encodeURIComponent(label)}`);
    }
  };

  const handleFilter = () => {
    let payload = filtersPayload(
      filters.healthConcern,
      filters.hospital,
      filters.gender,
      filters.country,
      filters.daysFilter,
      filters.fromDate,
      filters.toDate
    );
    payload.filters = true;
    payload.screen = "all";
    payload.source = "web";
    dispatch(fetchDashboardCountRequest(payload));
  };

  return (
    <Layout
      header="Dashboard"
      iconUrl="/home"
      showDateFilters={false}
      showFilters={true}
      handleFilter={handleFilter}
      setFilters={setFilters}
      filters={filters}
      // handleDateFilterApply={handleDateFilterApply}
    >
      <Box p={4}>
        {dashboardCount &&
          Object.entries(dashboardCount).map(([section, items]) => (
            <Box key={section} mb={8}>
              <PrimarySideHeader fontSize="2xl">
                {formatSectionName(section)}
              </PrimarySideHeader>
              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  sm: "repeat(2, 1fr)",
                  md: "repeat(3, 1fr)",
                  lg: "repeat(4, 1fr)",
                }}
                gap={6}
              >
                {items.map((item) => (
                  <GridItem
                    key={item.label}
                    onClick={() => handleCardClick(item.filter, item.label)}
                  >
                    <CountCard label={item.label} value={item.value} />
                  </GridItem>
                ))}
              </Grid>
            </Box>
          ))}
      </Box>
    </Layout>
  );
};

export default Dashboard;
